import { gql } from '@apollo/client';

export const GetMyVisualizationPresetsQueryName =
  'GetMyVisualizationPresets';

export const GET_MY_VISUALIZATION_PRESETS_QUERY = gql`
  query ${GetMyVisualizationPresetsQueryName} {
    getMyVisualizationPresets {
      id
      name
      createdAt
      updatedAt
      definitions {
        id
        filter {
          materials
          eras
          findTypes
          tags
        }
        style {
          shape
          primaryColor
          secondaryColor
          sizeScale
          outlined
        }
      }
    }
  }
`;
